import React, { FC, useCallback, useEffect, useRef } from "react";

interface Props {
  children: React.ReactElement<any>;
  clickOutside: (event: any) => void;
}

const ClickOutsideListener: FC<Props> = (props: Props) => {
  const { children, clickOutside } = props;
  const childRef = useRef(null);

  const eventHandler = useCallback(
    (event: any) => {
      if (!childRef.current) {
        return;
      }

      if (
        document.contains(event.target) &&
        !childRef.current.contains(event.target)
      )
        clickOutside(event);
    },
    [clickOutside]
  );

  useEffect(() => {
    document.addEventListener("click", eventHandler);

    return () => {
      document.removeEventListener("click", eventHandler);
    };
  }, [eventHandler]);

  return React.cloneElement(children, { ref: childRef });
};

export default ClickOutsideListener;
try {
    // @ts-ignore
    ClickOutsideListener.displayName = "ClickOutsideListener";
    // @ts-ignore
    ClickOutsideListener.__docgenInfo = { "description": "", "displayName": "ClickOutsideListener", "props": { "clickOutside": { "defaultValue": null, "description": "", "name": "clickOutside", "required": true, "type": { "name": "(event: any) => void" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/hoc/ClickOutsideListener/ClickOutsideListener.ts#ClickOutsideListener"] = { docgenInfo: ClickOutsideListener.__docgenInfo, name: "ClickOutsideListener", path: "src/shared/hoc/ClickOutsideListener/ClickOutsideListener.ts#ClickOutsideListener" };
}
catch (__react_docgen_typescript_loader_error) { }